module.exports = __webpack_public_path__ + "img/san.92c263a1.svg";